import { App } from './app.js';

function bootstrap(): void {
  const canvas = document.getElementById('stage');
  const overlay = document.getElementById('overlay');
  const controls = document.getElementById('controls');

  if (!(canvas instanceof HTMLCanvasElement)) {
    throw new Error('#stage canvas missing from DOM');
  }
  if (!(overlay instanceof HTMLElement)) {
    throw new Error('#overlay element missing from DOM');
  }
  if (!(controls instanceof HTMLElement)) {
    throw new Error('#controls element missing from DOM');
  }

  const app = new App({ canvas, overlay, controls });
  app.start();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootstrap, { once: true });
} else {
  bootstrap();
}
